import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import { IAppRoute } from 'interfaces/route';
import { IUserToken } from 'interfaces/userToken';
import React, { PureComponent } from 'react';
import { history } from '../../Pages/Admin';
import LogoDrawer from './Logo';
import Profile from './Profile';
import { ADMIN_URL_NEW } from '../../../settings';
import authService from 'services/auth';
interface IProps {
  classes?: any;
  user?: IUserToken;
  menu?: IAppRoute[];
}

interface IState {
  selectedRoute: string;
  userId: number;
}

@WithStyles({
  '@global': {
    '.MuiDrawer-paper': {
      top: '35px'
    }
  },
  root: {
    height: 'calc(100vh - 35px)',
    zIndex: 1200,
    outline: 'none',
    overflowY: 'auto',
    width: '250px',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-between'
  },
  svg: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: '25px 0',
    width: '100%'
  },
  option: {
    paddingBottom: 0,

    '& span': {
      color: '#FFF'
    },
    '& svg': {
      fill: '#FFF'
    }
  }
})
export default class Menu extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { selectedRoute: '/', userId: null };
  }

  componentDidMount() {
    const selectedRoute = history.location.pathname;
    this.setState({ selectedRoute });
    authService.getUser().subscribe(data => {
      this.setState({ userId: data?.id });
    });
  }

  handleClickItem(selectedRoute: string) {
    if (selectedRoute === '/orderbump') {
      authService.getUser().subscribe(data => {
        this.setState({ userId: data?.id });
      });

      window.location.href = `${ADMIN_URL_NEW}/orderbump`;
      return;
    }
    this.setState({ selectedRoute });
    history.push(selectedRoute);
  }

  isCurrentRoute(path: string) {
    const DEFAULT_ROUTE = '/customizer';
    const { selectedRoute } = this.state;

    return (selectedRoute === '/' && path === DEFAULT_ROUTE) || selectedRoute === path;
  }

  render() {
    const { user, menu } = this.props;
    const { root, svg, option } = this.props.classes;

    return (
      <Drawer variant="permanent" anchor="left" open>
        <div className={root}>
          <div>
            <div className={svg}>
              <LogoDrawer />
            </div>
            <Profile user={user} />
            <List className={option}>
              {menu.map(option => (
                <ListItem
                  button
                  className={this.isCurrentRoute(option.path) ? 'active' : ''}
                  key={option.path}
                  onClick={() => this.handleClickItem(option.path)}
                >
                  <ListItemIcon>{option.sideDrawer.icon}</ListItemIcon>
                  <ListItemText primary={option.sideDrawer.display} />
                </ListItem>
              ))}
            </List>
          </div>
          <List className={option}></List>
        </div>
      </Drawer>
    );
  }
}
